var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-widgets/lib/scss/react-widgets.scss';
import 'nprogress/nprogress.css';
import 'flag-icon-css/sass/flag-icons.scss';
import Notifications from "../Notifications";
import Cookiepopup from "./Cookiepopup";
import { TranslateForm, t } from "../I18N";

import { Icon } from "../UI";

import "./scss/styles.scss";

import Menu from "./Menu";
import SiteName from "./SiteName";
import Confirm from "./Confirm";
import GoogleAnalytics from "./GoogleAnalytics";
import Matomo from "./Matomo";

class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { showmenu: false, confirmOptions: {} };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  getChildContext() {
    return {
      confirm: this.confirm.bind(this)
    };
  }

  toggleMenu() {
    this.setState({ showmenu: !this.state.showmenu });
  }

  confirm(options) {
    this.setState({ confirmOptions: options });
  }

  renderTools() {
    return React.Children.map(this.props.children, (child) => {
      //condition not tested
      if (child.type.renderTools) {
        return child.type.renderTools();
      }

      return undefined;
    });
  }

  render() {
    const { routes, location, params } = this.props;
    let MenuButtonIcon = 'bars';
    let navClass = 'menuNav';

    if (this.state.showmenu) {
      MenuButtonIcon = 'times';
      navClass += ' is-active';
    }

    const customHomePageId = routes.reduce((memo, route) => {
      if (Object.keys(route).includes('customHomePageId')) {
        return route.customHomePageId;
      }
      return memo;
    }, '');

    const pageId = location.pathname.match('page/') && params.sharedId ? params.sharedId : '';

    const appClassName = customHomePageId || pageId ? `pageId_${customHomePageId || pageId}` : '';

    return /*#__PURE__*/(
      _jsx("div", { id: "app", className: appClassName }, void 0, /*#__PURE__*/
      _jsx(Notifications, {}), /*#__PURE__*/
      _jsx(Cookiepopup, {}), /*#__PURE__*/
      _jsx("div", { className: "content" }, void 0, /*#__PURE__*/
      _jsx("nav", {}, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0, /*#__PURE__*/
      _jsx(SiteName, {}))), /*#__PURE__*/


      _jsx("header", {}, void 0, /*#__PURE__*/
      _jsx("button", {
        className: "menu-button",
        onClick: this.toggleMenu,
        "aria-label": t('System', 'Menu', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: MenuButtonIcon })), /*#__PURE__*/

      _jsx("h1", { className: "logotype" }, void 0, /*#__PURE__*/
      _jsx(SiteName, {})),

      this.renderTools(), /*#__PURE__*/
      _jsx(Menu, { location: location, onClick: this.toggleMenu, className: navClass })), /*#__PURE__*/

      _jsx("div", { className: "app-content container-fluid" }, void 0, /*#__PURE__*/
      React.createElement(Confirm, this.state.confirmOptions), /*#__PURE__*/
      _jsx(TranslateForm, {}),
      this.props.children, /*#__PURE__*/
      _jsx(GoogleAnalytics, {}), /*#__PURE__*/
      _jsx(Matomo, {})))));




  }
}

App.defaultProps = {
  params: {},
  routes: []
};









App.childContextTypes = {
  confirm: PropTypes.func,
  locale: PropTypes.string
};

App.contextTypes = {
  getUser: PropTypes.func,
  router: PropTypes.object
};

export default App;